// La nouvelle interface, épurée (9 octobre 2026) : les pays de l'export.
export default {
  titre: 'Pays de l’export',
  sousTitre: 'Un pays se lit à travers ses propres formats : {n} étalons, leur audience de lancement, l’envie que sa population leur donne',
  sousTitreSansNombre: 'Un pays se lit à travers ses propres formats : leur audience de lancement, l’envie que sa population leur donne',
  erreur: {
    liste: 'Pays illisibles',
    releve: 'Relevé refusé',
    etalonnage: 'Étalonnage refusé',
  },
  chiffres: {
    sur: 'sur {n}',
    etalonnes: 'pays étalonnés, prêts à recevoir un format',
    audiences: 'audiences d’étalons validées',
  },
  carte: {
    invitation: 'Commencez par un pays où vos formats ont une chance : il s’étalonne en une fois.',
    prets: '{n} pays a assez d’étalons validés pour s’étalonner tout de suite. | {n} pays a assez d’étalons validés pour s’étalonner tout de suite. | {n} pays ont assez d’étalons validés pour s’étalonner tout de suite.',
    tousEtalonnes: 'Tous les pays de l’export ont leur étalonnage.',
    choisir: 'Le pays à étalonner',
    option: '{pays} ({n} sur {total})',
  },
  regions: {
    libelle: 'Régions',
    tous: 'Tous les pays',
    europe: 'Europe',
    ameriques: 'Amériques',
    asieOceanie: 'Asie et Océanie',
    afrique: 'Afrique',
    moyenOrient: 'Moyen-Orient',
    autres: 'Autres',
  },
  legende: 'Les pays de l’export et leurs formats étalons',
  colonne: {
    pays: 'Pays',
    etalons: 'Étalons validés',
    etat: 'État',
    action: 'Action',
  },
  reference: 'Référence',
  etalonsSur: '{n} sur {total}',
  aValider: '{n} à valider',
  etat: {
    aEtalonner: 'À étalonner',
    etalonneLe: 'Étalonné le {moment}',
  },
  suite: {
    voir: 'Voir l’étalonnage',
    suivre: 'Suivre l’étalonnage',
    relire: 'Relire le protocole',
    etalonner: 'Étalonner',
    relancer: 'Relancer l’étalonnage',
    valider: 'Valider les étalons',
    relever: 'Relever les étalons',
    completer: 'Compléter les étalons',
    ouvrir: 'Ouvrir sa fiche',
  },
  suiteDe: '{action} ({pays})',
  vide: 'Aucun pays au catalogue de l’export.',
  aucun: 'Aucun pays dans cette région.',
  sansEtalon: {
    voir: 'Voir les {n} pays sans étalon validé',
    masquer: 'Masquer les pays sans étalon validé',
  },
}
